// extracted by mini-css-extract-plugin
export default {"cls1":"Br15iwAMH2HVNbILfo6T","cls2":"_4CSbjwzszuaGMRLREGN Br15iwAMH2HVNbILfo6T","isPhone":"wpoQC3RNcsiHrYSgOCAk"};